import { call, put, select, takeLatest } from 'redux-saga/effects';

import { ACTIVE_EVENT_DELETED } from '../../actions/events';
import AMPLITUDE_EVENT_NAMES from '../../../amplitude/constants';
import { COLLECTION } from '../../../constants/collection';
import { FIELDS, POSTER_FIELDS } from '../../../constants/eventForm';
import { deletePoster } from './utils/file';
import { getActiveEvent } from '../selectors';
import { getActiveManageEventId } from '../selectors';
import { logAmplitudeEvent } from '../../actions/amplitude';
import store from '../../store/store';
import { validateUser } from './utils/auth';

const deleteActiveEvent = function* deleteActiveEvent() {
  const authUser = yield call(validateUser);
  const activeEvent = yield call(getActiveEvent);
  const activeManageEventId = yield select(getActiveManageEventId);
  yield store.firestore.delete({
    collection: COLLECTION.EVENTS,
    doc: activeManageEventId,
  });
  yield put(logAmplitudeEvent(AMPLITUDE_EVENT_NAMES.EVENT_DELETED, {
    id: activeManageEventId,
    categories: Object.keys(activeEvent[FIELDS.CATEGORIES]),
    title: activeEvent[FIELDS.TITLE],
  }));
  yield call(
    deletePoster,
    authUser.uid,
    activeEvent[FIELDS.POSTER][POSTER_FIELDS.KEY],
    activeEvent[FIELDS.POSTER][POSTER_FIELDS.ID],
  );
};

const watchDeleteActiveEvent = function* watchDeleteActiveEvent() {
  yield takeLatest(ACTIVE_EVENT_DELETED, deleteActiveEvent);
};

export { watchDeleteActiveEvent }


// WEBPACK FOOTER //
// ./src/redux/sagas/events/delete.js